var changeTitle= function (str){
    document.title = (str||'') + '蜗考，成就更好的自己'
}

export default changeTitle;


// WEBPACK FOOTER //
// ./src/js/changeTitle.js